import { Skeleton } from '@platform/design-system';
import type { TypedClient } from '@platform/openapi';
import { StockMatrix, type StockRow } from './StockMatrix.tsx';
import { useStockMatrix } from './useStockMatrix.ts';
import { LoadFailed } from '../LoadFailed.tsx';
import { usePageContext } from '../usePageContext.ts';

export type VariantStockProps = {
  api: TypedClient;
  rows: readonly StockRow[];
  labelledBy?: string | undefined;
};

export const VariantStock = ({ api, rows, labelledBy }: VariantStockProps) => {
  const { describeError } = usePageContext();
  const stock = useStockMatrix(
    api,
    rows.map((row) => row.variantId),
  );
  if (stock.isError) return <LoadFailed description={describeError(stock.error)} onRetry={stock.refetch} />;
  if (stock.isPending) return <Skeleton height="96px" />;
  return (
    <StockMatrix labelledBy={labelledBy} rows={rows} locations={stock.locations} levels={stock.levels} />
  );
};
